<template>
  <!-- 单个会话消息 -->
  <div
    v-if="messageDataType === 'object'"
    :class="[
        'origin-' + (message.from === 2 ? 'user' : 'robot'),
        !isChild || message.from === 2 ? 'chat-wrapper' : ''
      ]"
  >
    <component
      :is="bubble"
      :message="message"
      :types="message.type"
      :isChild.sync="isFolder"
      :class="'bubble-type-' + message.type"
    >
    </component>
  </div>
  <div
    v-else
    class="component-root"
    :class="isFolder ? 'chat-wrapper' : ''"
  >
    <div
      :class="[isFolder && 'chat-robot-box', isBlock && 'is-block']"
      :style="isBlock && 'display: block;'"
    >
      <!-- 会话消息组合 -->
      <component
        v-for="msg in message"
        :key="msg.id"

        :is="bubble"
        :types="message.type"
        :isChild.sync="isFolder"
        :message="msg"
        :isBlock="isBlock"
      >{{msg.type}}</component>
    </div>
  </div>

</template>

<script>
import './Bubbles/style.scss'

const typeOf = input => {
  const typeGetter = /\[object\s([a-z]+)\]/
  return Object.prototype.toString
    .call(input)
    .toLowerCase()
    .replace(typeGetter, '$1')
}

export default {
  name: 'ChatBubble',
  props: {
    message: [Array, Object, Boolean],
    types: Number,
    isChild: Boolean
  },
  data () {
    return {
      isFolder: false
    }
  },
  computed: {
    messageDataType () {
      return typeOf(this.message)
    },
    bubble () {
      // webpack 通过路径最为id加载资源包，为了保证同样组件的引用被识别为不同的组件需要加参数
      // 定义不同的 Bubble 加载的方法
      const bubbleLoader = {
        '-1': () => import('@/components/Bubbles/Tip'), // 灰色提示文案：背景文字
        0: () => import('@/components/Bubbles/Text'), // 欢迎语
        1: () => import('@/components/Bubbles/Part'), // l 首页推荐业务列表
        2: () => import('@/components/Bubbles/Hot'), // 业务,
        3: {
          loader: () => import('@/components/Bubbles/Hot'), // 考试列表
          options: {
            title () {
              return '请选择您要咨询的考试名称'
            }
          }
        },
        4: () => import('@/components/Bubbles/Download'), // 下载列表
        7: () => import('@/components/Bubbles/RelQuestion'), // 相关问题列表
        8: () => import('@/components/Bubbles/RelQuestion'), // 您可能关注下列相关问题
        10: () => import('@/components/Bubbles/Image'), // 您可能关注下列相关问题
        12: () => import('@/components/Bubbles/RelBusiness'), // 相关业务
        17: () => import('@/components/Bubbles/Part'), // 栏目
        18: () => import('@/components/Bubbles/Tip'), // 热点咨询话术 18;
        20: () => import('@/components/Bubbles/Download'), // 地址选择
        21: () => import('@/components/Bubbles/DistrictSelector'), // 地址选择
        22: () => import('@/components/Bubbles/Contact'), // 联系方式
        23: () => import('@/components/Bubbles/SubQuestion'), // 二级问题
        888: () => import('@/components/Bubbles/TextResponse'), // 文本答案
        exam: () => import('@/components/Bubbles/Exam'), // 业务对应的考试列表
        feedback: () => import('@/components/Bubbles/Feedback'), // 反馈标记
        loading: () => import('@/components/Bubbles/Loading'), // 提问的 loading
        commit: () => import('@/components/Bubbles/Comment'),
        anchor: () => import('@/components/Bubbles/Anchor')
      }
      // console.log(this.message, 'this.messageDataType')
      if (this.messageDataType === 'array') {
        return () => new Promise(resolve => {
          import('@/components/ChatBubble').then(mod => {
            const exports = mod.default
            this.isFolder = true
            resolve(exports)
          })
        })
      } else {
        // console.log(this.message, '看一下值')
        const type = this.message.type
        const loader = bubbleLoader[type]
        if (typeOf(loader) === 'object') {
          const { loader: loaderFn, options } = loader

          return () => new Promise((resolve) => {
            loaderFn().then(mod => {
              const exports = mod.default
              const data = {}
              const computed = {}

              if (options) {
                Object.keys(options).forEach(key => {
                  const value = options[key]

                  if (typeOf(value) === 'function') {
                    computed[key] = value
                  } else {
                    data[key] = value
                  }
                })
              }

              // 混入赋值
              exports.mixins = [{
                data () {
                  return data
                },
                computed
              }]
              resolve(exports)
            })
          })
        } else if (typeOf(loader) === 'function') {
          return loader
        }
        return {
          render (h) {
            console.log(this.message)
            return h('div', [
              h('div', 'Bubble component NOT FOUND !!!'),
              h('div', this.message)
            ])
          }
        }
      }
    },
    isBlock () {
      if (typeOf(this.message) === 'array') {
        return this.message.filter(item => item.type !== 0 || item.type !== 888).length > 0
      } else {
        return false
      }
    }
  }
}
</script>
